var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3119 0H3.86193C1.82836 0 0.173828 1.6542 0.173828 3.6881V15.5911C0.173828 17.6204 1.82115 19.2719 3.84883 19.2792V24.6806L11.6113 19.2792H23.3119C25.3454 19.2792 27 17.6246 27 15.5911V3.6881C27 1.6542 25.3454 0 23.3119 0ZM25.4281 15.5911C25.4281 16.7578 24.4788 17.7073 23.3119 17.7073H11.1181L5.42068 21.672V17.7073H3.86193C2.695 17.7073 1.74567 16.7578 1.74567 15.5911V3.6881C1.74567 2.52101 2.695 1.57184 3.86193 1.57184H23.3119C24.4788 1.57184 25.4281 2.52101 25.4281 3.6881V15.5911Z",
    fill: "#084F8C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 5.55402H19.8199V7.12586H7.35352V5.55402Z",
    fill: "#084F8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 8.90729H19.8199V10.4791H7.35352V8.90729Z",
    fill: "#084F8C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35352 12.2606H19.8199V13.8324H7.35352V12.2606Z",
    fill: "#084F8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/Comments.b0417491336d9a954ee3c2e9b76050d6.svg";
export { ForwardRef as ReactComponent };